
import { defineComponent } from "vue";
// import PasswordReset from "@/components/PasswordReset.vue";
import { ACTIONS } from "../data";

export default defineComponent({
  name: "LoginRegisterView",
  components: {
    // PasswordReset
  },
  data() {
    return {
      loginErrorMessage: "",
      signupErrorMessage: "",
      loginForm: {
        email: "",
        password: ""
      },
      signupForm: {
        name: "",
        email: "",
        password: ""
      },
      showLoginForm: true
      // showPasswordReset: false
    };
  },
  methods: {
    toggleForm() {
      this.showLoginForm = !this.showLoginForm;
    },
    // togglePasswordReset() {
    //   this.showPasswordReset = !this.showPasswordReset;
    // },
    login() {
      this.$store
        .dispatch(ACTIONS.login, {
          email: this.loginForm.email,
          password: this.loginForm.password
        })
        .then((err: string) => {
          console.log(err);
          if (err) {
            this.loginErrorMessage = err;
          } else {
            this.loginErrorMessage = "";
          }
        })
        .catch((err: any) => {
          console.error(err);
        });
    },
    signup() {
      this.$store
        .dispatch(ACTIONS.signup, {
          email: this.signupForm.email,
          password: this.signupForm.password,
          name: this.signupForm.name
        })
        .then(() => (this.signupErrorMessage = ""))
        .catch((error: string) => {
          this.signupErrorMessage = error;
        });
    }
  }
});
